import React from 'react';
import withAnalytics, { AnalyticsProps } from '../../analytics';

type InputComponentType = {
	className?: string;
	errors: { [name: string]: { message: string | undefined } };
	type: string | undefined;
	name: string;
	max: string | undefined;
	maxLength: number | undefined;
	minLength: number | undefined;
	placeholder: string | undefined;
	register: Function;
	required: boolean | undefined;
	onChange: Function | undefined;
	setShowReset: React.Dispatch<React.SetStateAction<boolean>>;
	onFocusHandler: (event: React.FocusEvent<HTMLInputElement>) => void;
	onBlurHandler: (event: React.FocusEvent<HTMLInputElement>) => void;
};

const Input: React.FC<InputComponentType & AnalyticsProps> = ({
	errors,
	type,
	name,
	max,
	maxLength,
	minLength,
	placeholder,
	register,
	required,
	onChange,
	setShowReset,
	onFocusHandler,
	onBlurHandler,
	className,
	...props
}) => {
	return (
		<input
			className={className}
			id={`form-input-${name}`}
			aria-invalid={errors.name ? 'true' : 'false'}
			type={type ? type : 'text'}
			name={name}
			max={max}
			maxLength={maxLength}
			minLength={minLength}
			placeholder={placeholder}
			ref={register({ required })}
			onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
				if (onChange) {
					onChange(event.target.value);
				}
				setShowReset(event?.currentTarget?.value.length > 0);
			}}
			onFocus={onFocusHandler}
			onBlur={onBlurHandler}
			{...props}
		/>
	);
};

const InputComponent = withAnalytics(Input);
export default InputComponent;
